<template>
  <div>
    <v-card
      v-if="section"
      class="elevation-0 px-0"
    >
      <v-toolbar
        dense
        card
      >
        <v-toolbar-title><small>{{ section }}</small></v-toolbar-title>
      </v-toolbar>
    </v-card>
    <v-layout
      v-show="!hide"
      row
      wrap
      align-baseline
    >
      <v-flex
        md4
        class="hidden-sm-and-down"
      >
        <span>{{ fieldName }}</span>
      </v-flex>
      <v-flex
        xs12
        md8
      >
        <slot />
      </v-flex>
      <v-flex
        v-if="divider"
        xs12
        md8
        offset-md4
      >
        <v-divider />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    divider: {
      type: Boolean,
      default: false,
    },
    name: {
      default: '',
      type: String,
      required: false,
    },
    hide: {
      type: Boolean,
      required: false,
      default: false,
    },
    section: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    fieldName: function () {
      return this.name ? this.name + ':' : ''
    },
  },
}
</script>
